exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu[data-v-3bd87bf8] {\n  display: block;\n}\n", ""]);

// exports
